module.exports = __webpack_public_path__ + "static/media/indexTopBg.13baf190.png";